import React, {useMemo} from "react";

import PropTypes from "prop-types";
import LogoSvg from "shared/assets/Logo.svg";
import { useInfo } from "utils/hooks/info";

import "./styles.scss";
import {useTranslation} from "react-i18next";
import {NAME_SPACES} from "../../locals/constants";
import {PrivacyPolicyDocument} from "../../../screens/public/PrivacyPolicyDocument";
import {PrivacyPolicyLink} from "../PrivacyPolicyLink";

const Logo = ({ withDesc, ...props }) => {
  const {
    info: { logo, desc },
  } = useInfo();

  return (
    <div className="site-logo">
      <img src={logo || LogoSvg} alt="" {...props} />
      {withDesc && (
        <div>
          <span>{desc}</span>
          <span style={{display:"block"}} className={"privacy-policy-link"}><PrivacyPolicyLink/></span>
        </div>)}

    </div>
  );
};

Logo.propTypes = {
  withDesc: PropTypes.bool.isRequired,
};

export default Logo;
